import { hooks } from "./hookactions"

export let QUTOfferingAdminUpload = { hooks }
